import { format } from '@dt/fe-utils'
import { map, filter } from '@dt/fe-utils/dist/lodash'
import { amountAdd } from 'common/utils'

class OrdersController {
  static OrderStatusMap: any = {
    Pending: 'order.waitpay',
    Success: 'order.success2',
    Cancel: 'order.cancel',
    Timeout: 'order.timeout',
    Paying: 'order.waitpay',
    refund: 'order.refund',
  }
  static OrderEatType: any = {
    dinein: 'order.dinein',
    togo: 'order.togo',
    pickup: 'order.pickup',
    mall: 'order.mall',
    delivery: 'order.delivery',
    giftcardCz: 'mkt.record.giftcardCz',
    giftcard: 'mkt.record.giftcard',
    memberCz: 'mkt.record.memberCz',
    memberCardBuy: 'mkt.record.memberCardBuy',
    memberCardRenew: 'mkt.record.memberCardRenew',
    redeemCouponByMoney: 'mkt.record.redeemCouponByMoney2',
    integralRedeem: 'mkt.record.integralRedeem',
  }
  static transformData (data: any, _state: string) {
    const newObj: any = {
      nono: data.nono || '',
      orderType: _state,
      ordersType: data.ordersType,
      tableAlias: data.tableAlias,
      tableTent: data.tableTent,
      memberId: data.memberId,
      eatType: data.eatType,
      isToday: data.isToday || 0,
      channel: data.channel,
      storeId: data.storeId
    }
    if (_state === 'meal' || _state === 'mall' || data.ordersType === 'dc' || data.ordersType === 'mall') {
      newObj.ordersId = data.ordersId || ''
      newObj.eatType = data.eatType
      newObj.time = data.acceptTime || data.addTime
      newObj.imgs = this.ProductPictures(data)
      newObj.desc = this.getProductNames(data)
      // newObj.storeName = data.storeName
      newObj.price = data.paidFee + data.tax
      newObj.cnt = data.cnt
      newObj.startTime = data.startTime
      newObj.payMode = data.payMode
      newObj.tableCode = data.tableCode
      newObj.status = data.status
      newObj.memberOrder = data.memberOrder
      newObj.sourceType = data.sourceType
      newObj.expressList = data.expressList
      newObj.detailList = data.detailList.filter((item) => data.ordersType === 'dc' || item.itemType === 'product' || item.itemType === 'mallProduct')
      newObj.picsProduct = data.picsProduct
      newObj.statusShowName = data.statusShowName
      newObj.refundTime = data.refundTime
      newObj.kdsInfo = data.kdsInfo
      data.ordersType === 'dc' && (newObj.ordersRefundList = data.ordersRefundList)
      newObj.storeName = data.storeName || data.subject.indexOf('-') >= 0 ? data.subject.slice(data.subject.indexOf('-') + 1) : ''
      if (data.eatType === 'dinein') {
        newObj.diningMode = data.diningMode
      }
    } else {
      newObj.ordersId = data.ordersId
      // newObj.eatType = data.eatType
      newObj.time = data.payTime
      newObj.status = data.refundTime ? 'refund' : data.status
      if (data.eatType === 'redeemCouponByMoney') {
        newObj.cnt = data.detailList?.[0]?.cnt || data.details?.length || 0
      } else {
        newObj.cnt = data.details?.length || 0
      }
      newObj.imgs = []
      if (data.details && data.details.length) {
        if (data.eatType === 'redeemCouponByMoney') {
          newObj.imgs = data.details[0].coupons ? data.details[0].coupons : []
          newObj.desc = ''
          newObj.price = data.paidFee
        } else {
          newObj.cardType = i18n.t(`order.${data.details[0].cardType}`)
          newObj.cardNo = data.details[0].cardNo
          newObj.productName = data.details[0].productName
          newObj.desc = this.getCardInfo(data.details[0])
          newObj.price = data.paidFee || data.details[0].balanceRechargeChange
        }
      }
    }
    return newObj
  }
  static getProductNames (data: any) {
    const products = filter(data.detailList, detail => detail.itemType === 'product' || detail.itemType === 'mallProduct')
    return map(products, item => item.productName).join(', ')
  }
  static getCardInfo (data: any) {
    const couponCnt = data.coupons?.reduce((p: number, item: any) => (item.couponCnt || 0) + p, 0)
    if (data.expireTimeChangeUnit) {
      if (data.expireTimeChangeUnit === 'day') {
        return i18n.t('mkt.member.days', { number: data.expireTimeChangeValue })
      } else if (data.expireTimeChangeUnit === 'month') {
        let type = 'month'
        data.expireTimeChangeValue === 3 ? type = 'season' : data.expireTimeChangeValue === 6 ? type = 'halfYear' : type = 'month'
        return i18n.t(`mkt.member.${type}`)
      } else {
        return i18n.t(`mkt.member.${data.expireTimeChangeUnit}`)
      }
    } else {
      let priceTips = `${i18n.t('order.charge', { price: format.toPrice(data.balanceRechargeChange) })} ${data.balanceGiveChange ? (',' + i18n.t('order.send', { price: format.toPrice(data.balanceGiveChange) })) : ''}`
      if (data.typeSub === 'discountFee') {
        return `${i18n.t('order.chargeFull', { price: ` ${format.toPrice(amountAdd(data.balanceRechargeChange, data.balanceGiveChange))}` })} ${data.balanceGiveChange ? (',' + i18n.t('order.chargeSub', { price: ` ${format.toPrice(data.balanceGiveChange)}` })) : ''} ${data.coupons ? (',' + i18n.t('order.sendCoupon', { num: couponCnt })) : ''}`
      }
      return `${priceTips} ${data.coupons ? (',' + i18n.t('order.sendCoupon', { num: couponCnt })) : ''}`
    }
  }
  static ProductPictures (data: any) {
    return data.pics?.length ? data.pics.map(item => {
      try {
        return item ? JSON.parse(item)[0]?.url : ''
      } catch (error) {
        return item
      }
    }) : []
  }
}
export default OrdersController
